import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { InvestmentAllocation } from "../../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { Table } from "../../../../../../../Shared/Table/Table";
import { SectionHeader } from "../../../../Common/SharedComponents";
import { ChooseAssetsToSellAssets } from "../../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";

interface IAssetsToSellTableProps {
    existingData: InvestmentAllocation[];
    tableData: InvestmentAllocation[];
}

interface IAssetsToSellTableState {}

export class AssetsToSellTable extends FormComponent<IAssetsToSellTableProps, IAssetsToSellTableState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { tableData } = this.props;
        const total = tableData
            ? tableData.reduce((sum, curr) => {
                  return (sum = sum + curr.Percentage);
              }, 0)
            : [];

        return (
            <>
                <h2 className="mt-48">Disinvest selection</h2>
                <Table
                    data={tableData}
                    col={[
                        {
                            title: "Investments",
                            key: "Name",
                            render: (data, row, index) => {
                                return <a className="hyper-link">{data}</a>;
                            },
                        },
                        {
                            title: "Existing allocation",
                            key: "Value",
                            render: (data, row, index) => {
                                return <span>{data?.Amount}</span>;
                            },
                        },
                        {
                            title: "New allocation",
                            key: "Percentage",
                        },
                    ]}
                    TotalBody={[
                        { data: "Total", colSpan: 2 },
                        { data: <span className={total == 100 ? "text-positive" : "text-text"}>{total}%</span> },
                    ]}
                />
            </>
        );
    }

    private getExistingAllocation(currentInstrument: InvestmentAllocation) {
        if (!isNullOrEmpty(this.props.existingData)) {
            return this.props.existingData.filter((data) => data.Id === currentInstrument.Id);
        }
    }
}
